




















































































import { Component, Prop } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { mixins } from 'vue-class-component';
import { RootState } from '@/store/store';
import dayjs from 'dayjs';
import {
  Invitation,
  Pagination
} from '@/store/modules/admin/types/admin.types';
import { InvitationAction } from '../mixins/invitation-action.mixin';
import { ApiState } from '@/store/types/general.types';
import { PaginationMixin } from '../../../components/base/pagination.mixin';
import BasePagination from '../../../components/base/BasePagination.vue';
import TableActionDropdown from '../../../components/TableActionDropdown.vue';
import SortableTableHeader from '../../../components/SortableTableHeader.vue';
import BaseTable from '../../../components/BaseTable.vue';

@Component({
  components: {
    BaseTable,
    BasePagination,
    TableActionDropdown,
    SortableTableHeader
  }
})
export default class UserInvitationHistoryList extends mixins(
  PaginationMixin,
  InvitationAction
) {
  sortHeaders = [
    { placeholder: 'Product', sortColumn: 'applicationId', sort: false },
    {
      placeholder: 'Date',
      sortColumn: 'invitationDate',
      sort: true
    },
    {
      placeholder: 'Invitation Type',
      sortColumn: 'latestActivity',
      sort: false
    },
    { placeholder: 'Status', sort: false }
  ];

  @Prop() public email!: string;
  @Prop() public items!: Invitation[];
  @Prop(Number) public currentPage!: number;
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;
  @Prop(String) public sortColumn!: string;
  @Prop(String) public sortOrder!: 'ASC' | 'DESC';

  @State((state: RootState) => state.admin.userInvitations)
  public userInvitations!: Pagination<Invitation>;

  @Action('admin/getUserInvitations')
  public getUserInvitations!: (params: {
    email: string;
    sortOrder: 'ASC' | 'DESC';
    sortColumn: string;
  }) => Promise<void>;

  @State((state: RootState) => state.admin.apiState.getUserInvitations)
  public getUserInvitationsState!: ApiState;

  @State((state: RootState) => state.admin.apiState.removeUserInvitation)
  public removeUserInvitationState!: ApiState;

  get invitations() {
    if (this.userInvitations) {
      return this.userInvitations.items || [];
    }
    return [];
  }

  public getStatus(invitation: Invitation) {
    const { expiredAt, acceptedAt } = invitation;
    const expiryDate = dayjs(new Date(expiredAt));
    const expired = dayjs().isAfter(expiredAt);
    if (acceptedAt) {
      return 'Accepted';
    }
    return expired ? 'Expired' : 'Pending';
  }

  get dayjs() {
    return dayjs;
  }

  public onClickHeaderColumn(columnName: string) {
    if (this.sortColumn === columnName) {
      return this.$emit('sort', {
        sortColumn: columnName,
        sortOrder: this.sortOrder === 'ASC' ? 'DESC' : 'ASC'
      });
    }
    this.$emit('sort', {
      sortColumn: columnName,
      sortOrder: 'DESC'
    });
  }

  public getSortOrderOfColumn(name: string) {
    if (this.sortColumn === name) {
      return this.sortOrder;
    }
    return 'ASC';
  }
}
